import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { signal } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class HealthCheckService {
  backendStatus = signal<'up' | 'down'>('up');

  constructor(
    private http: HttpClient,
    private router: Router,
  ) {}

  redirectAfterServerError() {
    this.backendStatus.set('down');
    this.router.navigate(['auth/login']);
  }

  checkBackend() {
    if (this.backendStatus() === 'up') {
      this.http.get(environment.apiUrl + '/health').subscribe({
        next: () => this.backendStatus.set('up'),
        error: (err) => {
          console.error('healthcheck nok:', err);
          this.redirectAfterServerError();
        },
      });
    }
  }
}
